import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";

import styles from "./Header.module.css";
import Language from "../utils/Language";
import Routes from "../constants/routes.json";

const navClass = ({ isActive }) =>
  isActive ? `${styles.NavButton} ${styles.NavButtonActive}` : styles.NavButton;

const drawerClass = ({ isActive }) =>
  isActive
    ? `${styles.DrawerLink} ${styles.DrawerLinkActive}`
    : styles.DrawerLink;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };

    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
  }

  openDrawer() {
    this.setState({ open: true });
    document.body.style.overflow = "hidden";
  }

  closeDrawer() {
    this.setState({ open: false });
    document.body.style.overflow = "";
  }

  render() {
    const { open } = this.state;

    return (
      <React.Fragment>
        <header className={styles.Outer}>
          <div className={styles.Inner}>
            <Link to={Routes.home} className={styles.Brand} aria-label="Uelstudios">
              <img
                className={styles.BrandLogo}
                alt="Uelstudios"
                src={require("../media/branding/uelstudios_logo.png")}
              />
            </Link>

            <nav className={styles.Nav}>
              <NavLink end to={Routes.home} className={navClass}>
                {Language.GetString("nav_new")}
              </NavLink>
              <NavLink to={Routes.games} className={navClass}>
                {Language.GetString("nav_games")}
              </NavLink>
              <NavLink to={Routes.dev} className={navClass}>
                {Language.GetString("nav_dev")}
              </NavLink>
            </nav>

            <button
              type="button"
              className={styles.MobileMenuButton}
              aria-label="Menu"
              onClick={this.openDrawer}
            >
              <span />
            </button>
          </div>
        </header>

        <div
          className={
            open ? `${styles.Drawer} ${styles.DrawerOpen}` : styles.Drawer
          }
        >
          <div className={styles.DrawerHead}>
            <Link
              to={Routes.home}
              className={styles.Brand}
              onClick={this.closeDrawer}
              aria-label="Uelstudios"
            >
              <img
                className={styles.BrandLogo}
                alt="Uelstudios"
                src={require("../media/branding/uelstudios_logo.png")}
              />
            </Link>
            <button
              type="button"
              className={styles.DrawerClose}
              aria-label="Close"
              onClick={this.closeDrawer}
            >
              ×
            </button>
          </div>
          <nav className={styles.DrawerNav}>
            <NavLink
              end
              to={Routes.home}
              className={drawerClass}
              onClick={this.closeDrawer}
            >
              {Language.GetString("nav_new")}
              <span>↗</span>
            </NavLink>
            <NavLink
              to={Routes.games}
              className={drawerClass}
              onClick={this.closeDrawer}
            >
              {Language.GetString("nav_games")}
              <span>↗</span>
            </NavLink>
            <NavLink
              to={Routes.dev}
              className={drawerClass}
              onClick={this.closeDrawer}
            >
              {Language.GetString("nav_dev")}
              <span>↗</span>
            </NavLink>
          </nav>
        </div>
      </React.Fragment>
    );
  }
}

export default Header;
